import { PaginationRequestBase } from "../pagination-request-base";

export class GetDashboardNotesRequest extends PaginationRequestBase {
  teamId?: number | null;
}

export class DashboardNotesFilterCriteria {
}